
export default class ImageLoaded {

	static init() {
		const lazyImgs = document.querySelectorAll("[loading='lazy']");

		lazyImgs.forEach((img) => {
			img.addEventListener('load', (e) => {
				img.classList.add('lazyloaded');
			});
		});
	}

}